
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"c-scroll-top\">\r\n    <span class=\"c-scroll-top__icon\"></span>\r\n    TOP\r\n</div>");